import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumb({ trail }) {
  const items = trail || [
    { label: "Home", to: "/" },
    { label: "Transportation and Logistics", to: "/browse/transportation" },
    { label: "EVRi", to: "/" },
    { label: "Reviews" },
  ];
  return (
    <div id="breadcrumb_wrapper" className="bg-[#f5f7f8] border-b border-gray-200">
      <div className="max-w-[1200px] mx-auto px-4 py-2.5 text-xs text-gray-600 flex items-center gap-1 flex-wrap">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <React.Fragment key={i}>
              {i > 0 && <ChevronRight size={12} className="text-gray-400"/>}
              {last || !it.to ? (
                <span className="text-gray-500">{it.label}</span>
              ) : (
                <Link to={it.to} className="text-[#007a8a] hover:underline">{it.label}</Link>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
